/**
 * https://www.pdftron.com/api/web/Core.DisplayModeManager.html#getDisplayMode__anchor
 */
export default () => window.documentViewer.getDisplayModeManager().getDisplayMode();
